module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/sidebar-shield-inactive.8f21e72b.svg";